import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  // 重定向（设定默认路由）
  {
    path: "/",
    redirect: "/index/home",
  },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/Layout/indexPage.vue"),
    redirect: "/index/home",
    children: [
      {
        path: "home",
        name: "indexPage",
        meta: { title: "首页" },
        component: () => import("../views/home/indexPage.vue"),
      },
      {
        path: "service",
        name: "servicePage",
        meta: { title: "服务" },
        component: () => import("../views/home/servicePage.vue"),
      },
      {
        path: "my",
        name: "myPage",
        meta: { title: "服务" },
        component: () => import("../views/home/myPage.vue"),
      },
    ],
  },
  {
    path: "/homePage",
    name: "homePage",
    meta: { title: "四川高速视频云点播" },
    component: () => import("../views/homePage/homePage.vue"),
  },
  {
    path: "/travelConsultation",
    name: "travelConsultation",
    meta: { title: "出行资讯" },
    component: () =>
      import("../views/travelConsultation/travelConsultation.vue"),
  },
  {
    path: "/indexService",
    name: "indexService",
    meta: { title: "服务区" },
    component: () => import("../views/serviceList/indexService.vue"),
  },
  {
    path: "/serviceDetails",
    name: "serviceDetails",
    meta: { title: "服务区详情" },
    component: () =>
      import("../views/serviceList/components/serviceDetails.vue"),
  },
  {
    path: "/SurroundingTours",
    name: "SurroundingTours",
    meta: { title: "周边旅游" },
    component: () => import("../views/SurroundingTours/surroundIndex.vue"),
  },
  {
    path: "/TollBoothHomepage",
    name: "TollBoothHomepage",
    meta: { title: "收费站" },
    component: () => import("../views/TollBoothHomepage/indexPage.vue"),
  },
  {
    path: "/tollStationClosed",
    name: "tollStationClosed",
    meta: { title: "收费站关闭列表" },
    component: () =>
      import("../views/TollBoothHomepage/components/tollStationClosed.vue"),
  },
  {
    path: "/liveBroadcast",
    name: "liveBroadcast",
    meta: { title: "慢直播" },
    component: () => import("../views/gasStation/liveBroadcast.vue"),
  },
  {
    path: "/TolboothHome",
    name: "TolboothHome",
    meta: { title: "收费站首页" },
    component: () => import("../views/TollBoothHomepage/TolboothHome.vue"),
  },
  {
    path: "/tollStationClosed",
    name: "tollStationClosed",
    meta: { title: "收费站关闭信息" },
    component: () =>
      import("../views/TollBoothHomepage/components/tollStationClosed.vue"),
  },
  {
    path: "/serviceAreaDetails",
    name: "serviceAreaDetails",
    meta: { title: "收费站详情" },
    component: () =>
      import("../views/TollBoothHomepage/components/serviceAreaDetails.vue"),
  },
  {
    path: "/sourroundDetails",
    name: "sourroundDetails",
    meta: { title: "周边旅游详情" },
    component: () =>
      import("../views/SurroundingTours/components/sourroundDetails.vue"),
  },
  {
    path: "/detailsIndex",
    name: "detailsIndex",
    meta: { title: "" },
    component: () =>
      import("../views/travelConsultation/details/detailsIndex.vue"),
  },
  {
    path: "/nearMe",
    name: "nearMe",
    meta: { title: "我的收藏" },
    component: () => import("../views/nearMe/nearMe.vue"),
  },
  {
    path: "/test",
    meta: { title: "测试" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/tempFile"),
  },
  {
    path: "/test2",
    meta: { title: "测试" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/tempFile2"),
  },
  {
    path: "/navigationIdex",
    meta: { title: "出行导航" },
    name: "navigationIdex",
    component: () => import("../views/navigation/navigationIdex"),
  },
  {
    path: "/navigationIdexDetail",
    meta: { title: "出行导航" },
    name: "navigationIdexDetail",
    component: () => import("../views/navigation/navigationIdexDetail"),
  },
  {
    path: "/navigationRoadLine",
    meta: { title: "出行导航" },
    name: "navigationRoadLine",
    component: () => import("../views/navigation/navigationRoadLine"),
  },
  {
    path: "/navigationNews",
    meta: { title: "最新概况" },
    name: "navigationNews",
    component: () => import("../views/navigation/navigationNews"),
  },
  {
    path: "/newRoads",
    meta: { title: "路况" },
    name: "newRoads",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/newRoads"),
  },
  {
    path: "/pathTolls",
    name: "pathTolls",
    meta: { title: "路径路费" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pathtolls/pathTolls.vue"
      ),
  },
  {
    path: "/pathTollsResult",
    name: "pathTollsResult",
    meta: { title: "路径路费查询结果" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/pathtolls/pathTollsResult.vue"
      ),
  },
  {
    path: "/warmHeartHome",
    name: "warmHeartHome",
    meta: { title: "暖心之家" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/warmhearthome/warmHeartHome.vue"
      ),
  },
  {
    path: "/warmHeartHomeDetail",
    name: "warmHeartHomeDetail",
    meta: { title: "暖心之家详情" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/warmhearthome/warmHeartHomeDetail.vue"
      ),
  },

  {
    path: "/gasStation",
    name: "gasStation",
    meta: { title: "加油站" },
    component: () => import("../views/gasStation/gasStation.vue"),
  },
  {
    path: "/gasStationInfo",
    name: "gasStationInfo",
    // meta: { title: "我的附近" },
    component: () => import("../views/gasStation/myNeighborhood.vue"),
  },
  {
    path: "/chargStation",
    name: "chargStation",
    meta: { title: "充电站" },
    component: () => import("../views/gasStation/chargStation.vue"),
  },
  {
    path: "/chargStationInfo",
    name: "chargStationInfo",
    meta: { title: "充电站详情" },
    component: () =>
      import("../views/gasStation/compoments/chargStationInfo.vue"),
  },
  {
    path: "/myNeighborhood",
    meta: { title: "我的附近" },
    name: "myNeighborhood",
    component: () => import("../views/myNeighborhood/myNeighborhood"),
  },
  {
    path: "/rdConditionBroadcast",
    name: "rdConditionBroadcast",
    meta: { title: "路况播报" },
    component: () => import("../views/rdCondition/rdConditionBroadcast.vue"),
  },
  {
    path: "/myCollection",
    meta: { title: "我的收藏" },
    name: "myCollection",
    component: () => import("../views/myCollection/myCollection"),
  },
  {
    path: "/trafficLive",
    meta: { title: "路况直播" },
    name: "trafficLive",
    component: () => import("../views/myCollection/compoments/trafficLive.vue"),
  },
  {
    path: "/myInfo",
    meta: { title: "个人资料" },
    name: "myInfo",
    component: () => import("../views/userInfo/userInfo.vue"),
  },
  //路况头条
  {
    path: "/latestConditions",
    meta: { title: "最新路况" },
    name: "latestConditions",
    component: () => import("../views/conditions/latestConditions.vue"),
  },
  // {
  //   path: "/collectList",
  //   meta: { title: "最新路况" },
  //   name: "latestConditions",
  //   component: () => import("../components/popUp/collectList.vue"),
  // },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
